<template>
  <div>
    <div class="--uppercase">{{ $t('tactics.instructions.inPossession.approachPlay.approachPlay') }}</div>

    <CheckboxTeamInstruction
      name="pass-into-space"
      :value="passIntoSpace"
      mutation="updatePassIntoSpace"
    >
      {{ $t('tactics.instructions.inPossession.approachPlay.passIntoSpace') }}
    </CheckboxTeamInstruction>

    <SelectTeamInstruction
      name="overlap-left"
      :value="overlapLeft"
      mutation="updateOverlapLeft"
      :options="options.overlapLeft"
    >
      {{ $t('tactics.pitchAreas.leftFlank') }}
    </SelectTeamInstruction>

    <SelectTeamInstruction
      name="overlap-right"
      :value="overlapRight"
      mutation="updateOverlapRight"
      :options="options.overlapRight"
    >
      {{ $t('tactics.pitchAreas.rightFlank') }}
    </SelectTeamInstruction>

    <CheckboxTeamInstruction
      name="play-out-of-defence"
      :value="playOutOfDefence"
      mutation="updatePlayOutOfDefence"
    >
      {{ $t('tactics.instructions.inPossession.approachPlay.playOutOfDefence') }}
    </CheckboxTeamInstruction>
  </div>
</template>

<script>
import { mapState } from "vuex";
import CheckboxTeamInstruction from "@/components/CheckboxTeamInstruction";
import SelectTeamInstruction from "@/components/SelectTeamInstruction";

export default {
  components: {
    CheckboxTeamInstruction,
    SelectTeamInstruction
  },

  data: function() {
    return {
      options: {
        overlapLeft: [
          { value: 1, label: 'tactics.instructions.inPossession.approachPlay.overlapLeft' },
          { value: 0, label: '', selected: true },
          { value: -1, label: 'tactics.instructions.inPossession.approachPlay.underlapLeft' },
        ],
        overlapRight: [
          { value: 1, label: 'tactics.instructions.inPossession.approachPlay.overlapRight' },
          { value: 0, label: '', selected: true },
          { value: -1, label: 'tactics.instructions.inPossession.approachPlay.underlapRight' },
        ]
      }/*,
      overlapLeft: {
        value: 'none',
        affects: null,
        label: 'left flank',
        possibleInstructions: [
          { value: 'overlap', label: 'tactics.instructions.inPossession.approachPlay.overlapLeft' },
          { value: 'none', label: '', selected: true },
          { value: 'underlap', label: 'tactics.instructions.inPossession.approachPlay.underlapRight' },
        ]
      },
      overlapRight: {
        value: 'none',
        affects: null,
        label: 'right flank',
        possibleInstructions: [
          { value: 'overlap', label: 'tactics.instructions.inPossession.approachPlay.overlapRight' },
          { value: 'none', label: '', selected: true },
          { value: 'underlap', label: 'tactics.instructions.inPossession.approachPlay.underlapRight' },
        ]
      }*/
    };
  },

  computed: mapState({
    passIntoSpace: state => state.instructions.inPossession.approachPlay.passIntoSpace,
    overlapLeft: state => state.instructions.inPossession.approachPlay.overlapLeft,
    overlapRight: state => state.instructions.inPossession.approachPlay.overlapRight,
    playOutOfDefence: state => state.instructions.inPossession.approachPlay.playOutOfDefence
  })
}
</script>

<style scoped>

</style>
